import { IFramework, IWebServiceManager, HttpMethod } from '@truckdown/framework';
import { ICaptchaService } from "./ICaptchaService";
import { CaptchaResponse } from './Models/CaptchaResponse';

export class CaptchaService implements ICaptchaService {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;
    private readonly basePath: string = '/tools/throttling/captcha';

    captchaKey: string = '6LfudwoTAAAAAOw785lNoE0QOVQZKfkZ4vSe8IJM';

    processResponse(captchaResponse: string): Promise<CaptchaResponse> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/' + encodeURIComponent(captchaResponse),
            method: HttpMethod.GET
        });

        return this.manager
            .get<any>(req)
            .then((res) => {
                return new CaptchaResponse(res);
            });
    }
}